import completeQuestions from "./QuestionsTestValues";
import IQuestionsDataStore from "./IQuestionsDataStore";

export class QuestionsBase extends IQuestionsDataStore {
    constructor ( dataStore ) {
        super()
        this.dataStore = dataStore
    }

    // Returns a promise
    create(questions) {
        return this.dataStore.create(questions)
    }
    
    // Returns a promise
    retrieve(product, version) {
        return this.dataStore.retrieve(product, version)
    }

    // Returns a promise
    retrieveTest(version) {
        return new Promise((resolve, reject) => {
            resolve(completeQuestions)
        })
    }

    // Returns a promise
    store(questions) {
        return this.dataStore.store(questions)
    }

    list(){
        return this.dataStore.list()
    }

    remove(version){
        return this.dataStore.remove(version)
    }
}

export default QuestionsBase